import axios from 'axios';

const deleteLog = id => axios.delete(`logs/${id}`);

export { deleteLog };
